/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { injectIntl } from 'react-intl';
import SVG from 'react-inlinesvg';
import { IconButton } from '@material-ui/core';
import { CancelOutlined } from '@material-ui/icons';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

function AlertViewSideMenu({ intl, isOpen, pendencies, closeMenu }) {
  return isOpen ? (
    <div
      className="col-md-2 col-lg-2 px-0 d-flex col-12 animate-enter flex-column justify-content-between"
      style={{ border: 'solid 1px #AAAAAA' }}
    >
      <div
        className="attention-bg p-2 d-flex align-items-center space-between"
        style={{ borderBottom: 'solid 1px #AAAAAA' }}
      >
        <div className="d-flex">
          <span className="svg svg-icon menu-icon mr-3 ml-1">
            <SVG
              uniquifyIDs
              src={toAbsoluteUrl('/media/svg/senseworks/alert-black.svg')}
            />
          </span>
          <label className="title font-size-h6 mb-0">
            {' '}
            {intl.formatMessage({ id: 'ATTENTION' })}{' '}
          </label>
        </div>
        <div>
          <IconButton type="button" onClick={closeMenu} className="p-1">
            <CancelOutlined />
          </IconButton>
        </div>
      </div>
      <div className="d-flex flex-column h-100 position-relative">
        <div style={{ overflowY: 'scroll' }}>
          {pendencies.initiator && (
            <span
              className="d-flex flex-column cursor-pointer"
              style={{ borderBottom: 'solid 1px #AAAAAA' }}
            >
              <div className="col-12 my-1 alert-view-card name">
                <h6 className="font-weight-bolder mb-0">
                  {intl.formatMessage({ id: 'PENDENCIES.INITIATOR.TITLE' })}
                </h6>
              </div>
              <div className="col-12 my-1 alert-view-card description">
                <span className="font-size-lg dark-grey">
                  {intl.formatMessage({ id: 'PENDENCIES.INITIATOR.BODY' })}
                </span>
                <span
                  className="font-size-lg dark-grey"
                  style={{ fontStyle: 'italic' }}
                >
                  {intl.formatMessage({ id: 'INITIATOR' }).toLowerCase()}.
                </span>
              </div>
            </span>
          )}
          {pendencies.bridge && (
            <span
              className="d-flex flex-column cursor-pointer"
              style={{ borderBottom: 'solid 1px #AAAAAA' }}
            >
              <div className="col-12 my-1 alert-view-card name">
                <h6 className="font-weight-bolder mb-0">
                  {intl.formatMessage({ id: 'PENDENCIES.BRIDGE.TITLE' })}
                </h6>
              </div>
              <div className="col-12 my-1 alert-view-card description">
                <span className="font-size-lg dark-grey">
                  {intl.formatMessage({ id: 'PENDENCIES.BRIDGE.BODY' })}
                </span>
                <span
                  className="font-size-lg dark-grey"
                  style={{ fontStyle: 'italic' }}
                >
                  {intl.formatMessage({ id: 'BRIDGE' }).toLowerCase()}.
                </span>
              </div>
            </span>
          )}
          {pendencies.geoAnchors && (
            <span
              className="d-flex flex-column cursor-pointer"
              style={{ borderBottom: 'solid 1px #AAAAAA' }}
            >
              <div className="col-12 my-1 alert-view-card name">
                <h6 className="font-weight-bolder mb-0">
                  {intl.formatMessage({ id: 'PENDENCIES.GEO_ANCHOR.TITLE' })}
                </h6>
              </div>
              <div className="col-12 my-1 alert-view-card description">
                <span className="font-size-lg dark-grey">
                  {intl.formatMessage({ id: 'PENDENCIES.GEO_ANCHOR.BODY' })}
                </span>
              </div>
            </span>
          )}
          {pendencies.processingGroup && (
            <span
              className="d-flex flex-column cursor-pointer"
              style={{ borderBottom: 'solid 1px #AAAAAA' }}
            >
              <div className="col-12 my-1 alert-view-card name">
                <h6 className="font-weight-bolder mb-0">
                  {intl.formatMessage({
                    id: 'PENDENCIES.PROCESSING_GROUP.TITLE',
                  })}
                </h6>
              </div>
              <div className="col-12 my-1 alert-view-card description">
                <span className="font-size-lg dark-grey">
                  {intl.formatMessage({
                    id: 'PENDENCIES.PROCESSING_GROUP.BODY',
                  })}
                </span>
              </div>
            </span>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className="d-none"></div>
  );
}

export default injectIntl(AlertViewSideMenu);
